import React from 'react';
import {
  ActionCard,
  ActionCardContainer,
  ActionRow,
  ActionPriceSection,
  InfoCircleIcon,
} from '@grays-npm/component-library';
import { AuctionDataRefClick } from './types/ListingActionHandlers';
import { ListingContactCard } from './ListingContactCard';
import { ListingAuctionContextSection } from './ListingContextSection';
import { ListingTimeSection } from './ListingTimeSection';
import type { ListingItem } from './types/ListingItem';
import { formatBadgeType } from './utils/formatBadgeType';
import TagManager from 'react-gtm-module';
import { LabelAction, LabelIcon } from './types/ListingLabel';
import {
  ListingModalTypeEnum,
  SetModalContentType,
} from '../../pages/Listings/Modals';

export type ListingEventProps = {
  onAuctionDataClick: AuctionDataRefClick;
  onReferredInfoModal: SetModalContentType<ListingModalTypeEnum.ReferredInfo>;
};

export type ListingProps = ListingEventProps & ListingItem;

const getLabelIcon = (labelIcon: LabelIcon | undefined) => {
  switch (labelIcon) {
    case 'Info':
      return InfoCircleIcon;
    default:
      return undefined;
  }
};

export const Listing: React.FC<ListingProps> = ({
  auctionContext,
  auctionState,
  timingData,
  type,
  imageUrl,
  label,
  labelIcon,
  labelAction,
  actionButtonContent,
  infoPanelContent,
  onAuctionDataClick,
  onReferredInfoModal,
  priceText,
  contactInfo,
}) => {
  const getLabelAction = (labelAction: LabelAction | undefined) => {
    switch (labelAction) {
      case 'ReferredInfoModal':
        return () =>
          onReferredInfoModal({
            type: ListingModalTypeEnum.ReferredInfo,
            data: {},
          });
      default:
        return undefined;
    }
  };

  return (
    <ActionCard
      badgeType={formatBadgeType(type)}
      badgeLabel={auctionState === 'sold' ? '' : label}
      imageUrl={imageUrl}
      imageHref={auctionContext?.auctionUrl}
      imageOnClick={() => {
        TagManager.dataLayer({
          dataLayer: {
            event: `${auctionState}Listings-clickProductName`,
          },
        });
        if (auctionContext?.auctionUrl)
          window.open(auctionContext.auctionUrl, '_blank');
      }}
      icon={getLabelIcon(labelIcon)}
      iconOnClick={getLabelAction(labelAction)}
    >
      <ActionCardContainer>
        <ListingAuctionContextSection
          {...auctionContext}
          auctionState={auctionState}
          onAuctionDataClick={onAuctionDataClick}
        />
        {infoPanelContent}
        <ActionRow actionButtonContent={actionButtonContent}>
          {timingData?.time && <ListingTimeSection {...timingData} />}
          {priceText && <ActionPriceSection priceText={priceText} />}
          {contactInfo && (
            <ListingContactCard
              title={contactInfo.contactName}
              subtitle="Grays staff member"
            />
          )}
        </ActionRow>
      </ActionCardContainer>
    </ActionCard>
  );
};
